import { toast } from 'react-toastify';

export function handleLogout(navigate) {
    localStorage.clear();
    navigate('/teleport-admin');
    toast.error('!..Session Expired, Please login again');
}